import { render, staticRenderFns } from "./China1VendorMap.vue?vue&type=template&id=1cc4a2cf&scoped=true&"
import script from "./China1VendorMap.vue?vue&type=script&lang=js&"
export * from "./China1VendorMap.vue?vue&type=script&lang=js&"
import style0 from "./China1VendorMap.vue?vue&type=style&index=0&id=1cc4a2cf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc4a2cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
